<div class="projekte-verwalten" [id]="id" data-testid="projekte-verwalten-popover">
  <div class="projekte-verwalten__titel">{{ 'home.meineProjekte.popoverTitel' | translate }}</div>
  <div class="projekte-verwalten__hinweis">{{ 'home.meineProjekte.popoverHinweis' | translate }}</div>
  @for (projekt of sortiert(); track projekt.projectId) {
    @let sichtbar = !ausgeblendet().has(projekt.projectId);
    @let istAngeheftet = angeheftet().has(projekt.projectId);
    <div class="projekte-verwalten__zeile">
      <label class="projekte-verwalten__auswahl">
        <input
          type="checkbox"
          class="projekte-verwalten__haekchen"
          data-testid="projekt-sichtbar"
          [checked]="sichtbar"
          (change)="haekchenGeaendert($event, projekt.projectId)"
        />
        <span class="projekte-verwalten__kuerzel" [style.background]="farbe(projekt)" [style.color]="schrift(projekt)">
          {{ projekt.kuerzel }}
        </span>
        <span class="projekte-verwalten__name" [class.projekte-verwalten__name--aus]="!sichtbar">
          {{ projekt.name }}
        </span>
        @if (!sichtbar) {
          <span class="sr-only">{{ 'home.meineProjekte.ausgeblendet' | translate }}</span>
        }
      </label>
      <button
        type="button"
        class="projekte-verwalten__stern"
        data-testid="projekt-anheften"
        [class.projekte-verwalten__stern--an]="istAngeheftet"
        [attr.aria-pressed]="istAngeheftet"
        [attr.aria-label]="
          (istAngeheftet ? 'home.meineProjekte.nichtMehrAnheften' : 'home.meineProjekte.anheften') | translate
        "
        [title]="(istAngeheftet ? 'home.meineProjekte.angeheftet' : 'home.meineProjekte.anheftenKurz') | translate"
        (click)="stern.emit(projekt.projectId)"
      >
        {{ istAngeheftet ? '★' : '☆' }}
      </button>
    </div>
  }
  <div class="projekte-verwalten__fuss">
    <button type="button" class="projekte-verwalten__fertig" (click)="schliessen.emit()">
      {{ 'home.meineProjekte.fertig' | translate }}
    </button>
  </div>
</div>
